import { SupportedChains, SUPPORTED_CHAIN_IDS } from '../config/constants';
import { NetworkConnector } from './NetworkConnector';
import { InjectedConnector } from '@web3-react/injected-connector';
import { WalletLinkConnector } from '@web3-react/walletlink-connector';
import { TrezorConnector } from '@web3-react/trezor-connector';
import { PortisConnector } from '@web3-react/portis-connector';
import { TorusConnector } from '@web3-react/torus-connector';
import { FortmaticConnector } from '@web3-react/fortmatic-connector';
import { SafeAppConnector } from '@gnosis.pm/safe-apps-web3-react';
import { UAuthConnector } from '@uauth/web3-react';
import LedgerHQConnector from './LedgerHQSigner/LedgerHQConnector';
import { BitkeepConnector } from './BitkeepConnector';
import { NaboxConnector } from './NaboxConnector';
import { MetamaskConnector } from './MetamaskConnector';
import { OKXConnector } from './OKXConnector';
import { WalletConnectV2Connector } from './WalletConnectV2Connector';

export const RPC_URLS = {
    // [SupportedChains.MAINNET]: `https://spool-test.solidant.io`,
    [SupportedChains.MAINNET]: `https://mainnet.infura.io/v3/${process.env.REACT_APP_INFURA_ID}`,
    // [SupportedChains.ROPSTEN]: `https://ropsten.infura.io/v3/${process.env.REACT_APP_INFURA_ID}`,
    // [SupportedChains.RINKEBY]: `https://rinkeby.infura.io/v3/${process.env.REACT_APP_INFURA_ID}`,
    // [SupportedChains.GOERLI]: `https://goerli.infura.io/v3/${process.env.REACT_APP_INFURA_ID}`,
    // [SupportedChains.KOVAN]: `https://kovan.infura.io/v3/${process.env.REACT_APP_INFURA_ID}`,
    [SupportedChains.ARBITRUM_ONE]: `https://arb1.arbitrum.io/rpc`,
};

const POLLING_INTERVAL = 12000;

export const networkConnector = new NetworkConnector({
    urls: {
        [SupportedChains.MAINNET]: 'https://eth.llamarpc.com',
        // [SupportedChains.MAINNET]: RPC_URLS[SupportedChains.MAINNET],
        // [networks.ROPSTEN]: RPC_URLS[networks.ROPSTEN],
        // [SupportedChains.RINKEBY]: RPC_URLS[SupportedChains.RINKEBY],
        // [networks.GOERLI]: RPC_URLS[networks.GOERLI],
        // [networks.KOVAN]: RPC_URLS[networks.KOVAN],
        // [SupportedChains.ARBITRUM_ONE]: `https://arbitrum-mainnet.infura.io/v3/${process.env.REACT_APP_INFURA_ID}`,
        [SupportedChains.ARBITRUM_ONE]: RPC_URLS[SupportedChains.ARBITRUM_ONE],
    },
    defaultChainId: SupportedChains.MAINNET,
});

export const gnosisSafe = new SafeAppConnector();

export const injected = new MetamaskConnector({
    supportedChainIds: SUPPORTED_CHAIN_IDS,
});

export const walletConnect = (chainId: SupportedChains) =>
    new WalletConnectV2Connector({
        rpcMap: {
            [SupportedChains.MAINNET]: RPC_URLS[SupportedChains.MAINNET],
            [SupportedChains.ARBITRUM_ONE]: RPC_URLS[SupportedChains.ARBITRUM_ONE],
        },
        projectId: 'f94e2ebc515f883636ba6a03ba1d7304',
        chainId: chainId,
        supportedChainIds: SUPPORTED_CHAIN_IDS,
        bridge: 'wss://relay.walletconnect.com',
    });

export const walletlink = new WalletLinkConnector({
    url: RPC_URLS[SupportedChains.MAINNET],
    supportedChainIds: SUPPORTED_CHAIN_IDS,
    appName: 'app.spool.fi',
});

export const trezor = new TrezorConnector({
    chainId: SupportedChains.MAINNET,
    url: RPC_URLS[SupportedChains.MAINNET],
    pollingInterval: POLLING_INTERVAL,
    manifestEmail: 'developer@xyz.com',
    manifestAppUrl: 'https://app.spool.fi',
});

export const portis = new PortisConnector({
    dAppId: 'e8bf51d3-ea8e-49e3-aad9-5dc6c3cf2b11',
    networks: [SupportedChains.MAINNET, 100],
});

export const ledger = (getPath: () => void) =>
    new LedgerHQConnector({
        chainId: SupportedChains.MAINNET,
        url: RPC_URLS[SupportedChains.MAINNET],
        pollingInterval: POLLING_INTERVAL,
        getPath: getPath,
    });

export const torus = new TorusConnector({ chainId: SupportedChains.MAINNET });

export const fortmatic = new FortmaticConnector({
    apiKey: 'pk_live_911E0486D54C05CE',
    chainId: SupportedChains.MAINNET,
});

export const uauth = (chainId: SupportedChains) =>
    new UAuthConnector({
        clientID: 'f00db251-d5fd-4f05-aeb5-3326b5a8e722',
        redirectUri: 'https://www.app.spool.fi',
        scope: 'openid wallet',
        connectors: { injected: injected, walletconnect: walletConnect(chainId) },
        supportedChainIds: SUPPORTED_CHAIN_IDS,
    });

export const bitkeep = new BitkeepConnector({
    supportedChainIds: SUPPORTED_CHAIN_IDS,
});

export const nabox = new NaboxConnector({
    supportedChainIds: SUPPORTED_CHAIN_IDS,
});

export const fox = new InjectedConnector({
    supportedChainIds: SUPPORTED_CHAIN_IDS,
});

export const okx = new OKXConnector({
    supportedChainIds: SUPPORTED_CHAIN_IDS,
});
